module.exports = __webpack_public_path__ + "static/media/time-up.1dd41963.svg";